import { useMutation, useQuery } from '@apollo/react-hooks';
import gql from 'graphql-tag';

const currentUserIdQuery = gql`
  query dismissibleJobsCtaCurrentUserId {
    currentUser: currentUserV2 {
      id
    }
  }
`;

const setHasSeenJobsCta = gql`
  mutation setHasSeenJobsCta($profileId: ID!, $hasSeenCta: Boolean!) {
    setHasSeenJobsCta(id: $profileId, hasSeenCta: $hasSeenCta) {
      hasSeenNotifications {
        jobsCta
      }
      id
    }
  }
`;

export type Props = {
  skip?: boolean;
};

export const useData = ({ skip }: Props = {}) => {
  const { data, loading } = useQuery(currentUserIdQuery, {
    skip,
  });

  const [dismissJobsCtaMutation] = useMutation(setHasSeenJobsCta);

  const dismissJobsCta = () =>
    dismissJobsCtaMutation({
      variables: {
        profileId: data?.currentUser?.id,
        hasSeenCta: true,
      },
    });

  return {
    dismissJobsCta,
    isLoading: loading,
    profileId: data?.currentUser?.id,
  };
};
